import styled from 'styled-components';
import { responsiveBreakPoints } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;

export const ArticleTop = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const ArticleTitle = styled.h4`
	color: #333;
	font-size: 42px;
	font-weight: 700;
	line-height: 130%;
	@media screen and (${maxTablet}) {
		font-size: 28px;
	}
`;
export const ArticleOffer = styled.span`
	color: #0060c3;
	font-size: 20px;
	line-height: 150%;
	text-decoration-line: underline;
`;
export const ArticleMeta = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	margin-bottom: 24px;

	img {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
		border-radius: 48px;
		@media screen and (${maxTablet}) {
			width: 40px;
			height: 40px;
			order: 1;
		}
	}
`;
export const WrittenBy = styled.p`
	color: #636363;
	font-size: 14px;
	font-weight: 400;
	line-height: normal;
	margin: 0 !important;
	@media screen and (${maxTablet}) {
		order: 2;
	}
`;
export const ArticleMetaText = styled.p`
	color: #636363;
	font-size: 14px;
	font-weight: 400;
	line-height: normal;
	margin: 0 !important;
	@media screen and (${maxTablet}) {
		order: 3;
	}
`;
